import bus from "./bus";

export default bus;
